import { axiosInstance, type CustomResponseFormat } from "api/instance";

export const REFUND_DOMAIN = "refund";
export const REFUND_SURVEY_SUBMIT_ENDPOINT = "survey/submit";
export const REFUND_REQUEST_ENDPOINT = "request";

export interface RefundSurveyType {
  questionId: number;
  answerId: number;
  answer: string;
}

export interface RefundSignatureType {
  signature: string;
}

export const refundApi = {
  submitSurvey: (body: RefundSurveyType) =>
    axiosInstance.post<CustomResponseFormat>(
      `${REFUND_DOMAIN}/${REFUND_SURVEY_SUBMIT_ENDPOINT}`,
      body
    ),

  request: (body: RefundSignatureType) =>
    axiosInstance.post<CustomResponseFormat>(
      `${REFUND_DOMAIN}/${REFUND_REQUEST_ENDPOINT}`,
      body
    ),
};
